"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.localityTypeByIdPrefix = exports.default = exports.LocalityTypeName = void 0;
var _forOwn = _interopRequireDefault(require("lodash/forOwn"));
var _values = _interopRequireDefault(require("lodash/values"));
var _localityState = _interopRequireDefault(require("./locality-state"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var localityNamePattern = '[\\w-]+';
var statePattern = () => {
  var states = [];
  (0, _forOwn.default)(_localityState.default, value => {
    states.push(value.abbreviation);
  });
  return "(".concat(states.join('|').toLowerCase(), ")");
};
var postcodePattern = '\\d{1,4}';
var LocalityTypeName;
(function (LocalityTypeName) {
  LocalityTypeName["DIVISION"] = "DIVISION";
  LocalityTypeName["DISTRICT"] = "DISTRICT";
  LocalityTypeName["REGION"] = "REGION";
  LocalityTypeName["STREET"] = "STREET";
  LocalityTypeName["POSTCODE"] = "POSTCODE";
  LocalityTypeName["SCHOOL"] = "SCHOOL";
})(LocalityTypeName || (exports.LocalityTypeName = LocalityTypeName = {}));
var LocalityType = {
  DIVISION: {
    type: LocalityTypeName.DIVISION,
    slugPattern: new RegExp("^(".concat(localityNamePattern, "-").concat(statePattern(), "-").concat(postcodePattern, ")$"), 'i'),
    shortSlugReplacement: '$1',
    idField: 'divisionId',
    idPrefix: 12
  },
  DISTRICT: {
    type: LocalityTypeName.DISTRICT,
    slugPattern: new RegExp("^(".concat(localityNamePattern, ")-district-(").concat(statePattern(), ")$"), 'i'),
    shortSlugReplacement: '$1-$2',
    idField: 'districtId',
    idPrefix: 11
  },
  REGION: {
    type: LocalityTypeName.REGION,
    slugPattern: new RegExp("^(".concat(localityNamePattern, ")-region-(").concat(statePattern(), ")$"), 'i'),
    shortSlugReplacement: '$1-$2',
    idField: 'regionId',
    idPrefix: 10
  },
  STREET: {
    type: LocalityTypeName.STREET
  },
  POSTCODE: {
    type: LocalityTypeName.POSTCODE
  },
  SCHOOL: {
    type: LocalityTypeName.SCHOOL
  }
};
var localityTypeByIdPrefix = idPrefix => (0, _values.default)(LocalityType).find(localityType => localityType.idPrefix === parseInt(idPrefix, 10));
exports.localityTypeByIdPrefix = localityTypeByIdPrefix;
var _default = exports.default = LocalityType;